// extracted by mini-css-extract-plugin
export default {"iconsContainer":"Socials_iconsContainer__6WbAF","icon":"Socials_icon__a30pt","aboutButton":"Socials_aboutButton__xAp6K","contractAddress":"Socials_contractAddress__gZ2TU"};